<div class="policy-wrapper" [ngClass]="isMobile === true ? 'policy-wrapper-mobile' : ''">
  <colimo-page-header [heading]="'privacyPolicy.heading'"> </colimo-page-header>
  <h3 [ngClass]="isMobile === true ? 'heading-mobile' : ''">
    <p>
      We are pleased about your visit to our website and your interest in our company. The topic of data protection has
      our highest priority. Therefore, we would like to inform you in detail about it in the following:
    </p>
  </h3>
  <p></p>
  <div class="agenda">
    <ul>
      <li><span class="section-link" (click)="scrollTo('section-a')">A. Who is responsible for data processing and who is our data protection officer?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-b')">B. What data do we process, for what purposes, for how long and on what legal basis?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-c')">C. Are you obliged to provide us with this data?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-d')">D. To whom do we pass on your personal data?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-e')">E. How do we safeguard your personal data?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-f')">F. What rights do you have?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-g')">G. Where can you complain?</span></li>
      <li><span class="section-link" (click)="scrollTo('section-h')">H. Data protection for minors</span></li>
    </ul>
  </div>
  <section id="section-a">
    <h3 class="letter-heading">A. Who is responsible for data processing and who is our data protection officer?</h3>
    <p>
      Please refer to the legal notice on the website of our group of companies that you are visiting for the contact
      details of the data controller.
    </p>
    <p>Our external Group Data Protection Officer can be contacted via:</p>
    <p>
      <b>Thomas Rosin</b>
      <br>Klaus-Groth-Str. 4
      <br>23611 Bad Schwartau
      <br>Germany
      <br>email: <a href="mailto:datenschutz@thomasrosin.de">datenschutz&#64;thomasrosin.de</a>
    </p>
  </section>
  <section id="section-b">
    <h3 class="letter-heading">B. What data do we process, for what purposes, for how long and on what legal basis?</h3>
    <p>
      In the following, we inform you about the data processing on our site (a), its purposes and legal basis (b) as well
      as the respective storage period and, if applicable, specific objection and removal options (c).
    </p>
    <h3 class="number-heading">1. Log files</h3>
    <div class="bold-heading">a. Data processing</div>
    <p>
      If you visit our website for information purposes only, i.e. if you do not register or transmit data in any other
      way (e.g. via a contact form), the following information is automatically transmitted from your browser to our
      server:
    </p>
    <ul>
      <li>IP address of your device</li>
      <li>Information about your browser</li>
      <li>Name of the website from which you visit us</li>
      <li>Name of the visited page (URL) or the opened file</li>
      <li>Date and time of your visit</li>
      <li>Status information such as error messages</li>
      <li>Transferred data volume and the access status (file transferred, file not found, etc.)</li>
      <li>Operating system and version of your computer's operating system and the name of your access provider</li>
    </ul>
    <div class="bold-heading">b. Purposes and legal basis</div>
    <p>
      When you visit our website, we use the IP address and other information automatically transmitted to our
      server by your browser under B. 1. a. to
    </p>
    <div>
      <div>(i) provide you with the requested content</div>
      <div>(ii) ensure the security and stability of our website and to trace unauthorized use</div>
      <div>(iii) enable a comfortable use of our website.</div>
    </div>
    <p>
      The legal basis for the data processing is Art. 6 para. 1 sentence 1 lit. f GDPR. Our legitimate interest follows
      from the above listed purposes for data processing. Under no circumstances do we use the collected data for the
      purpose of drawing conclusions about your person.
    </p>
    <div class="bold-heading">c. Storage period</div>
    <p>
      The data will be deleted as soon as they are no longer necessary for the purpose for which they were collected. In
      the case of the collection of data for the provision of the website, this is the case when the respective session is
      ended. In the case of storage of the data in log files, this is the case after seven days at the latest. Storage
      beyond this period is possible. In this case, the IP addresses are anonymized by deleting the last eight bits, so
      that an identification of you is no longer possible.
    </p>
    <h3 class="number-heading">2. Cookies and similar technologies</h3>
    <div class="bold-heading">a. Data processing and respective legal basis</div>
    <p>
      We use cookies and similar technologies (“cookies”) on our website . These are text information that can be stored in the browser on the device of the
      viewer to a visited website (web server, server). The cookie is either sent from the web server to the browser or generated in the browser by a script
      (JavaScript). The web server can read this cookie information directly from the server when the user visits this page again or transfer the cookie
      information to the server via a script of the website. Cookies do not cause any damage to your device, do not contain viruses, trojans or other malware.
    </p>
    <p>
      Information is stored in the cookie that is related to the specific device used. This does not mean, however, that we obtain direct knowledge of your identity.
    </p>
    <p>We generally use the following types of cookies:</p>
    <div class="bold-heading">Strictly necessary cookies</div>
    <p>
      These cookies are necessary for the functioning of the website. In general, these cookies are only set in response to actions
      you take in response to a service request, such as setting your privacy preferences, logging in, or filling out forms. You can set
      your browser to block these cookies or to notify you about these cookies. However, some areas of the website may not function properly.
    </p>
    <p>
      The legal basis for the processing of these cookies is Art. 6 para. 1 sentence 1 lit. f GDPR. Our legitimate interest follows from
      the data processing purposes listed under B.1.b.
    </p>
    <div class="bold-heading">Optional cookies</div>
    <p>
      Optional cookies are used for additional features and digital services of our website, such as analysing website usage to improve the
      information we provide or displaying multimedia content that we embed from other websites.
    </p>
    <p>
      The legal basis for the processing of these cookies is Art. 6 para. 1 sentence 1 lit. a GDPR.
    </p>
    <p>
      Further information on the cookies and digital services we use, the purposes for which we process data, and the retention periods can be found in our
      Privacy Preference Center (“Cookie Settings”, “Cookie Privacy Center”) on the website you are visiting.
    </p>
    <!-- legacy cookie button does it still work  -->
    <!--<div class="bold-heading">b. Specific use of cookies, purposes and storage period</div>
    <p>
      Specifically, we use the following cookies, depending on the cookie preferences you set in the Privacy Preference
      Center. Only the strictly necessary cookies are activated by default. If you do not want this either, you have the
      option of generally rejecting cookies in your browser. In this case, the functionality of the visited website may be
      impaired.
    </p>
    &lt;!&ndash; OneTrust Cookies List start &ndash;&gt;
    <div id="ot-sdk-cookie-policy"></div>
    &lt;!&ndash; OneTrust Cookies List end &ndash;&gt;
    <p>
      Further details about the respective cookie providers can be found in the Privacy Preference Center, under the
      respective cookie categories.
    </p>
    &lt;!&ndash; OneTrust Cookies Settings button start &ndash;&gt;
    <button mat-raised-button color="primary" (click)="openCookieBanner()" class="banner-button">Cookie Settings</button>
    &lt;!&ndash; OneTrust Cookies Settings button end &ndash;&gt;-->
    <h3 class="number-heading">3. Contact form and e-mail</h3>
    <div class="bold-heading">a. Data processing</div>
    <p>
      Our web pages contain contact forms as well as links to send us an e-mail directly. If you use one of these contact
      forms, the data which you provide in such forms will be transmitted to us and processed. The mandatory data that
      must be filled in for electronic contact via the respective contact form are marked with (*). If you provide us
      with additional data, this is done voluntarily.
    </p>
    <p>If you send us an e-mail, we will process the associated metadata and the content of the message.</p>
    <div class="bold-heading">b. Purpose and legal basis</div>
    <p>
      Your data will be processed to enable us to contact you, to process your request and to provide you with our
      respective services, to prevent misuse of the contact form and to ensure the security of our information
      technology systems.
    </p>
    <p>
      The legal basis for the processing of data classified as being mandatory is Art. 6 para. 1 sentence 1 lit. f GDPR.
      The aforementioned purposes also include a legitimate interest in the processing of the data. If the purpose of
      the contact is the conclusion of a contract, the additional legal basis for the processing is Art. 6 para. 1 sentence 1 lit.
      b GDPR. The legal basis for the processing of the data that you have voluntarily provided us with is your consent
      in accordance with Art. 6 para. 1 sentence 1 lit. a GDPR.
    </p>
    <div class="bold-heading">c. Storage period</div>
    <p>
      The personal data of the person concerned will be deleted or made unavailable as soon as the purpose of the storage
      does no longer apply. Furthermore, data may be stored if this has been provided for by the European or national
      legislator in EU regulations, laws or other regulations to which the person responsible is subject. Data will also
      be deleted or made unavailable when a storage period prescribed by the above-mentioned provisions expires, unless
      there is a need to continue storing the data for the purpose of concluding or fulfilling a contract.
    </p>
    <p>
      In case of a consent, you have the right to revoke such consent at any time, without affecting the lawfulness of
      the processing carried out on the basis of the consent until revocation. Please inform your respective contact
      partner at our company.
    </p>
    <h3 class="number-heading">4. Embedded YouTube videos</h3>
    <div class="bold-heading">a. Data processing</div>
    <p>
      We have integrated YouTube videos into our online offering, which are stored on the YouTube platform and can be
      played directly from our website. YouTube is a service of Google LLC, D/B/A YouTube. 901 Cherry Ave., San Bruno,
      CA 94066, USA (hereinafter as ‘Google’). The videos are all embedded in the so-called ‘2-click-mode’, which means
      that no data about you as a user is being transferred to Google if you do not activate the video function. Before
      the video function’s activation, only a preview image loaded from our own web server is being displayed.
    </p>
    <p>
      Data will only be transferred to Google if you activate such video functions. Once being activated, we have no
      influence on this data transfer. The data transfer is carried out regardless of whether Google provides a user
      account through which you are logged in or whether no user account exists. If you are logged in at Google,
      your data will be assigned directly to your account.
    </p>
    <div class="bold-heading">b. Purposes and legal basis</div>
    <p>We use YouTube videos on our website to present those to you in an easy way.</p>
    <p>
      The legal basis for the processing of your personal data is your consent according to Art. 6 para. 1 sentence 1
      lit. a GDPR. You grant this consent by activating the video function. If activated, your personal data will be
      transferred to Google as described above.
    </p>
    <p>
      In the course of the data transfer to Google, your personal data will be transferred to servers of Google,
      which might also be located in the USA. In general, the USA is a country that does have a level of data
      protection which is adequate to that of the EU. However, personal data can be accessed by US authorities
      in a simplified manner and there are only limited rights to such measures. If you activate the YouTube video
      function, you expressly consent to the transfer of data to Google and to the transfer of your personal data
      to servers located in the USA.
    </p>
    <p>
      If you have given your consent, you have the right to revoke it at any time without affecting the lawfulness
      of the processing carried out on the basis of the consent until revocation.
    </p>
    <p>
      You can revoke you consent at any time for the future by deactivating the slider of the category “YouTube” in
      the Privacy Preference Center (“Cookie Settings”, “Cookie Privacy Center”) on the website you are visiting.
    </p>
    <div class="bold-heading">c. Further information</div>
    <p>
      Further information on data processing, in particular on the legal basis and storage period by YouTube,
      can be found in the provider's privacy policy (<a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>) and in the privacy banner
      on the YouTube platform. There you will also find further information on your rights and setting options to
      protect your privacy.
    </p>
    <p>
      Google may also process your personal information in the United States, a third country with an adequate level
      of data protection.
    </p>
    <h3 class="number-heading">5. Embedded LinkedIn content</h3>
    <div class="bold-heading">a. Data processing</div>
    <p>
      We have integrated LinkedIn content into our online offering, which is stored on the LinkedIn platform and can be
      viewed directly from our website. LinkedIn is a service of LinkedIn Ireland Unlimited Company, Wilton Place,
      Dublin 2, Ireland (hereinafter as ‘LinkedIn’). The content is embedded in the so-called ‘2-click-mode’, which
      means that no data about you as a user is being transferred to LinkedIn if you do not activate the content.
      Before the content’s activation, only a preview image loaded from our own web server is being displayed.
    </p>
    <p>
      Data will only be transferred to LinkedIn if you activate the content. Once being activated, we have no influence
      on this data transfer. The data transfer is carried out regardless of whether LinkedIn provides a user account
      through which you are logged in or whether no user account exists. If you are logged in at LinkedIn, your data
      will be assigned directly to your account.
    </p>
    <div class="bold-heading">b. Purposes and legal basis</div>
    <p>We use LinkedIn content on our website to present those to you in an easy way.</p>
    <p>
      The legal basis for the processing of your personal data is your consent according to Art. 6 para. 1 sentence 1 lit.
      a GDPR. You grant this consent by activating the content. If activated, your personal data will be transferred to
      LinkedIn as described above.
    </p>
    <p>
      In the course of the data transfer to LinkedIn, your personal data will be transferred to servers of LinkedIn,
      which might also be located in the USA. In general, the USA is a country that does have a level of data protection
      which is adequate to that of the EU. However, personal data can be accessed by US authorities in a simplified
      manner and there are only limited rights to such measures. If you activate the LinkedIn content, you expressly
      consent to the transfer of data to LinkedIn and to the transfer of your personal data to servers located in the USA.
    </p>
    <p>
      If you have given your consent, you have the right to revoke it at any time without affecting the lawfulness of
      the processing carried out on the basis of the consent until revocation.
    </p>
    <p>
      You can revoke your consent at any time for the future by deactivating the slider of the category “LinkedIn” in the
      Privacy Preference Center (“Cookie Settings”, “Cookie Privacy Center”) on the website you are visiting.
    </p>
    <div class="bold-heading">c. Further information</div>
    <p>
      Further information on data processing, in particular on the legal basis and storage period by LinkedIn, can be
      found in the provider's privacy policy (<a href="https://de.linkedin.com/legal/privacy-policy">https://de.linkedin.com/legal/privacy-policy</a>) and in the privacy banner
      on the LinkedIn platform. There you will also find further information on your rights and setting options to
      protect your privacy.
    </p>
    <p>
      LinkedIn may also process your personal information in the United States, a third country with an adequate level
      of data protection.
    </p>
    <h3 class="number-heading">6. Social media hyperlink</h3>
    <p>We have included hyperlinks to the following social media services on our website: LinkedIn and YouTube.</p>
    <p>
      These hyperlinks are designed in the form of the corresponding logos and are stored on our own server. This means
      that when our website is loaded for the first time, no data about you as a user are transferred to the respective
      provider. You will be directed to the respective website only if you click on the logos. Further data about you
      may be processed on this website.
    </p>
    <p>We have no influence on this data processing on the respective linked websites.</p>
    <h3 class="number-heading">7. Direct marketing</h3>
    <p>
      If you have given us your consent to do so, we will process your personal data to provide you with personalized
      information on our products, events, web seminars and services we consider relevant for you via the communication
      channels you have selected.
    </p>
    <p>
      In order to determine your professional needs and interests, we combine and analyse the personal data that we have
      collected about you in the course of your relationship with us as a customer or user of our products and services
      (in particular your contract and master data, the products you have purchased, samples, demos, brochures or
      whitepapers that you have requested or downloaded, webinars for which you have registered, surveys that you have
      completed, etc.).
    </p>
    <p>The legal basis for the processing of your personal data for the above-mentioned purposes is your consent.</p>
    <p>
      As our sales and marketing teams operate worldwide, we will, where necessary, share your personal data with
      other Surventis companies:
    </p>
    <p></p>
    <ul>
      <li>Chemetall S.R.L., Tucuman, 1, C1049AAA, Buenos Aires, Argentina</li>
      <li>Chemetall (Australasia) Pty. Ltd., Turbo Drive Bayswater, 17, 3153, Melbourne, Australia</li>
      <li>BASF Coatings Pty Ltd., City Road, Level 23, 40, VIC 3006, Southbank, Australia</li>
      <li>BASF Coatings Services GmbH, Gewerbestrasse, 25, 5301, Eugendorf, Austria</li>
      <li>Chemetall BV, Rijksweg, 14, 2880, Bornem, Belgium</li>
      <li>BASF Coatings Services SA, Rijksweg, 14, 2880, Bornem, Belgium</li>
      <li>Chemetall do Brasil Ltda., Rua Luiz Benezato, 100 Jardim E, 13.212-161, Jundiai, Brazil</li>
      <li>Automotive Refinish Technologies Inc., Lenworth Drive, 3227, L4X 2G6, Mississauga, Canada</li>
      <li>Chemetall Canada Limited, Creekbank Road, Building A Floor 2, 5025, L4W 0B6, Mississauga, Canada</li>
      <li>BASF Coatings Inc., Creekbank Road, 5025, L4W 0B6, Mississauga, Canada</li>
      <li>Zhejiang Chemetall Surface Treatment Materials Co. Ltd, Bai Sha Road Dushan Port Pinghu, 1199, 311204, Jiaxing, China</li>
      <li>Chemetall (Shanghai) International Trading Co., Ltd., No 188 A-746, Yesheng Road, 201306, Shanghai, China</li>
      <li>BASF Coatings (Guangdong) Co., Limited, No. 81, Xin Le San Lu, 529060, Jiangmen, China</li>
      <li>Shanghai Chemetall Chemicals Co., Ltd., Kang'an Road, Kangqiao Industrial Zone, 628, 201315, Shanghai, China</li>
      <li>Changchun Chemetall Chemicals Co., Ltd., Chao Ran Jie Street, High & New Technology Development Zone, 1889, 130103, Changchun, China</li>
      <li>BASF Coatings Technology (Shanghai) Co., Ltd., Jiang Xin Sha Road, 300, 200137, Shanghai, China</li>
      <li>BASF (Shanghai) Coatings Manufacturing Co., Ltd., Chuhua Road, Fengxian District Building 18, 28, 201400, Shanghai, China</li>
      <li>BASF Coatings (Changchun) Co., Ltd. , Phase 1, Zone A, Mingyu Finance Plaza, 130000, Changchun, China</li>
      <li>BASF Shanghai Coatings Co. Ltd., 521 Guanghua Road / Zhuanqian Town, 201108, Shanghai, China</li>
      <li>BASF Coatings S.A.S., Calle 99, N° 69C-32, 110010, Bogotá, Colombia</li>
      <li>Chemetall Kft., Radlická, 354/107b, 158 00, Praha, Czech Republic</li>
      <li>Chemetall AB, Kalvebod Brygge, 45, 1560, Copenhagen V, Denmark</li>
      <li>BASF Coatings A/S, Kalvebod Brygge, 45, 1560, København V, Denmark</li>
      <li>Chemetall AB, Kuninkaankatu, 24 B, 33210, Tampere, Finland</li>
      <li>BASF Coatings Oy, Tammasaarenkatu, 3, 00180, Helsinki, Finland</li>
      <li>Chemetall S.A.S., avenue des Louvresses, 8, 92622, Gennevilliers, France</li>
      <li>Knight Chimiques de Spécialité S.A.S., avenue des Louvresses, 8, 92230, Gennevilliers, France</li>
      <li>BASF Coatings Services S.A.S., Rue Jean-Mermoz, 16, 77290, Compans, France</li>
      <li>Société Foncière et Industrielle S.A.S., Rue Andre Pommery, Zone Industrielle de Breuil-le-Sec, 60676, Clermont de l'Oise, France</li>
      <li>BASF Coatings France SAS, Rue André Pommery, 60840, Breuil-le-Sec, France</li>
      <li>BASF Coatings Services GmbH, Minister-Stein-Allee, 6, 44339, Dortmund, Germany</li>
      <li>BASF Coatings GmbH, Glasuritstrasse, 1, 48165, Münster, Germany</li>
      <li>Polyscale innovations GmbH, Eilendorfer Straße, 215, 52078, Aachen, Germany</li>
      <li>Rockwood Specialties Group GmbH, Trakehnerstr., 3, 60487, Frankfurt (Main), Germany</li>
      <li>Chemetall GmbH, Trakehner Straße, 3, 60487, Frankfurt (Main), Germany</li>
      <li>BASF Coatings Ltd., Two Taikoo Place, 979 King's Road, 36/F, Hong Kong, Hong-Kong</li>
      <li>Chemetall Hungária Vegyianyagokat Forgalmazó Korlátolt Felelösségü Társasag, Váci út, 96-98, 1133, Budapest, Hungary</li>
      <li>Chemetall India Private Ltd., Village Koregaon Bhima, Pune Nagar Road, Tal Shirur, Dist., 569, 412207, Pune, India</li>
      <li>BASF India Coatings Private Limited, Godrej One, Pirojsha Nagar, Eastern Express Highway, Vikroli, 10A,10B,10C, 400 079, Mumbai, India</li>
      <li>PT BASF Coatings Indonesia, DBS Bank Tower, 26th Floor, Ciputra World 1, 12940, Jakarta, Indonesia</li>
      <li>BASF Coatings Services Italy Srl, Via Marconato, 8, 20811, Cesano Maderno, Italy</li>
      <li>Chemetall S.R.L., Piazza San Fedele, 4, 20121, Milan, Italy</li>
      <li>Chemetall Italia S.r.l., Piazza San Fedele, 4, 20121, Milano, Italy</li>
      <li>KENDELL S.r.l., Piazza San Fedele, 4, 20121, Milano, Italy</li>
      <li>BASF Coatings S.R.L., Via Marconato, 8, 20811, Cesano Maderno, Italy</li>
      <li>BASF Coatings Japan LLC, Shimokurata-cho, Totsuka-ku, 296, 244-0815, Yokohama, Japan</li>
      <li>BNC Color Techno Co., Ltd., 296,Shimokurata-cho, Totsuka-ku, Yokohama-shi, 244-0815, Kanagawa, Japan</li>
      <li>Chemetall Mexicana, S.A. de C.V., Av. El I epeyac, 1420-B, 76250, El Marques, Mexico</li>
      <li>BASF Coatings Mexicana, S.A. de C.V., Ave. Uno, Parque Industrial Cartagena, 9, 54918, Tultitlán, Mexico</li>
      <li>BASF Coatings SARLAU, Boulevard Sidi Mohamed Ben Abdellah, La Marina Tou, 3, 20000, Casablanca, Morocco</li>
      <li>BASF Coatings Services B.V., Industrieweg, 12, 3606 AS, Maarssen, Netherlands</li>
      <li>Chemetall B.V., Ijsselstraat, 41, 5347 KG, Oss, Netherlands</li>
      <li>Brent International B.V., Denbigh Road, 65, MK 1 1PB, Bletchley, Netherlands</li>
      <li>BASF Coatings and Chemetall New Zealand Limited , Rosebank Road, 527A, 1026, Auckland City, New Zealand</li>
      <li>BASF Coatings AS, Lilleakerveien, 2B, 0283, Oslo, Norway</li>
      <li>BASF Coatings + Inks Philippines Inc., 101 M. Alvarez Avenue, Talon las Pinas, 1254, Makati, Philippines</li>
      <li>Chemetall Philippines Co. Ltd. Inc., n/a, n/a, n/a, n/a, Philippines</li>
      <li>BASF Coatings Services Sp. z o.o., Aleje Jerozolimskie, 142B, 02-305, Warschau, Poland</li>
      <li>Chemetall Polska Sp. z o.o., ul. Przeclawska, 8, 03-879, Warschau, Poland</li>
      <li>BASF Coatings Services S.A., Rua 25 de Abril, 1, 2685-368, Prior Velho, Portugal</li>
      <li>Chemetall S.A., Rua 25 de Abril, 1, 2685-368, Prior Velho, Portugal</li>
      <li>BASF Coatings LLC, Puerto Rico</li>
      <li>BASF Coatings Services S.R.L., Floreasca Park, Sos. Pipera, 43, Bldg. A, 014254, Bukarest, Romania</li>
      <li>Chemetall Asia Pte. Ltd., Loyang Crescent Road, 12, 508980, Singapore, Singapore</li>
      <li>Chemetall Kft., Einsteinova, 23, 85101, Bratislava, Slovakia</li>
      <li>BASF Coatings Services (Pty.) Ltd., 16th Road, 852, 1685, Midrand, South Africa</li>
      <li>Chemetall (Proprietary) Ltd., Sellers Road Boksburg East, 5, 1460, Boksburg, South Africa</li>
      <li>BASF Coatings Espanola S.L.U. (prev. BASF Coatings Services S.A.U.), Avenida Cristóbal Colón, 19180, Marchamalo, Spain</li>
      <li>Chemetall S.A. Unipersonal, Paseo de la Ribera, 107, 8420, Canovelles, Spain</li>
      <li>Chemetall AB, Backa Strandgata, 18, 42246, Hisings Backa, Sweden</li>
      <li>BASF Coatings Services AB, Transportgatan, 37-39, 42502, Hisings Kärra, Sweden</li>
      <li>Chemetall GmbH, Aarauerstraße, 51, 5200, Brugg, Switzerland</li>
      <li>BASF Coatings Services AG, Huobstrasse, 3, 8808, Pfäffikon, Switzerland</li>
      <li>Chemetall Surface Treatment Holding Co., Ltd., Nimitkul Building, Soi Rama IX 57/1 (Wisetsook 2) Suanluang, 88, 10250, Bangkok, Thailand</li>
      <li>Chemetall (Thailand) Co. Ltd., Nimitkul Building, Soi Rama IX 57/1 (Wisetsook 2) Suanluang, 88, 10250, Bangkok, Thailand</li>
      <li>BASF Coatings Co. Ltd, 307-308 Moo.4 Soi 5, Bangpoo Industrial Estate, Su, 10280, Samutprakarn, Thailand</li>
      <li>BASF Coatings Boya Sanayi ve Ticaret Limited Şirketi, Barbaros Mah. Begonya Sk. Nidakule Ataşehir Bati, 1 D:48, 34746, Istanbul, Turkey</li>
      <li>Chemetall Sanayi Kimyasallari Ticaret ve Sanayi A.S., TOSB Organize Sanayi Bölgesi 3, 21, 41480, Kocaeli, Turkey</li>
      <li>Chemetall India Company Ltd., Denbigh Road, 65, MK1 1PB, Bletchley, United Kingdom</li>
      <li>A.M. Craig Limited , Denbigh Road, 65, MK1 1PB, Bletchley, United Kingdom</li>
      <li>Chemetall Ltd., Napier House Auckland Park, MK1 1BU, Bletchley, United Kingdom</li>
      <li>Androx Ltd., Denbigh Road, 65, MK1 1PB, Bletchley, United Kingdom</li>
      <li>Brent Europe Ltd., Denbigh Road, 65, MK1 1PB, Bletchley, United Kingdom</li>
      <li>Chemserve Ltd., Denbigh Road, 65, MK1 1PB, Bletchley, United Kingdom</li>
      <li>The Brent Manufacturing Company Ltd., Denbigh Road, 65, MK1 1PB, Bletchley, United Kingdom</li>
      <li>BASF Coatings UK Limited, Railway Road, 2, SK1 3GG, Stockport, United Kingdom</li>
      <li>Automotive Refinish Technologies, LLC, Telegraph Road, 26701, 48033, Southfield, USA</li>
      <li>Chemetall U.S., Inc., Central Avenue, 675, 07974, New Providence, USA</li>
      <li>BASF Coatings LLC, Park Avenue, 100, 07932, Florham Park, New Jersey, USA</li>
      <li>Bond Services LLC, Orange Street, 1209, 19801, Wilmington, USA</li>
      <li>BASF Coatings and Chemetall Middle East - L.L.C - S.P.C, 16th Street, 20000, Abu Dhabi, Utd.Arab Emir.</li>
      <li>BASF Coatings Vietnam Co. Ltd., Le Duan Street, Ben Nghe Ward, District 1, 33, 700000, Ho Chi Minh, Vietnam</li>
    </ul>
    <p>
      In addition, we will share your personal data between those Surventis companies which are responsible for you as
      a (prospective) business partner. Both of the aforementioned transfers serve the purpose of administration of
      customer data across the Surventis and preparation of global marketing campaigns and sales-related activities.
    </p>
    <p>
      The legal basis for this data sharing is our legitimate interest in maintaining your personal data in our
      company group.
    </p>
    <p>
      We will share your personal data with other affiliated companies of the Surventis if they provide IT services for
      us or if this is necessary for operational reasons, such as follow ups from sales managers or developing
      personalized marketing materials and content. Furthermore, we will pass on your personal data to the technical
      IT service providers we use from whom we obtain services. Our IT service providers are carefully selected and
      regularly checked by us. They process personal data only on our behalf and strictly in accordance with our
      instructions on the basis of corresponding contracts for order processing.
    </p>
    <p>
      We store your personal data collected within the scope of your consent for the above-mentioned purposes until
      your consent is revoked.
    </p>
    <p>
      You can revoke your consent at any time with effect for the future by notifying us of your revocation under our
      Privacy Preference Center (“Cookie Settings”, “Cookie Privacy Center”) on the website you are visiting. Each
      marketing mail we will send to you based on this consent, will contain a separate link to revoke your consent.
    </p>
    <p>You are at liberty to grant or withhold consent. This has no effect on your visit of this website and platform.</p>
    <p>
      If you revoke your consent, we will no longer use your personal data for marketing purposes unless we have another
      legal basis for this. The revocation of your consent does not affect the legality of the data processing that
      has taken place up to that point.
    </p>
    <h3 class="number-heading">8. User Account</h3>
    <p>
      If you have been registered via the Surventis registration process, we will process the following personal data
      for the purposes of providing you with access to our website and to administrate your user account:
    </p>
    <ul>
      <li>First Name</li>
      <li>Last Name</li>
      <li>Company</li>
      <li>E-Mail Address</li>
    </ul>
    <p>
      The registration process is based on an individual basis, during which we process personal data depending on the
      type of communication channel, e.g. e-mail or phone.
    </p>
    <p>
      The legal basis for this data processing is our legitimate interest in accordance with Art. 6 Sec. 1 lit. f) GDPR,
      which consists of the purposes as mentioned above.
    </p>
  </section>
  <section id="section-c">
    <h3 class="letter-heading">C. Are you obliged to provide us with this data?</h3>
    <p>
      When you visit our website, the information specified in section B. 1. a. as well as the information from the
      cookies classified as strictly necessary is processed automatically. The transfer of this information is voluntary.
      Without the provision of this personal data, we cannot display the requested page.
    </p>
    <p>If you</p>
    <ul>
      <li>allow us to use cookies that are not classified as strictly necessary or </li>
      <li>want to see embedded YouTube videos</li>
    </ul>
    <p>the transfer of the information is voluntary.</p>
    <p>
      If you contact us, we cannot answer your inquiry in the chosen way without the provision of the personal data
      required in the individual case. As far as cookies are concerned, the lack of consent can lead to a restriction
      of the functionality of the website or parts of it. Embedded videos cannot be played without your consent.
    </p>
  </section>
  <section id="section-d">
    <h3 class="letter-heading">D. To whom do we pass on your personal data?</h3>
    <p>
      Within our company, only persons and departments are granted access to your personal data as far as they need it
      to fulfil the abovementioned purposes. In addition, we will forward your personal data to other Surventis
      Companies, if they are responsible for you.
    </p>
    <p>
      We also involve service providers. These service providers will only act on our instructions and are
      contractually obliged to comply with the applicable data protection requirements.
    </p>
    <p>Otherwise, we will only pass on your data to third parties if:</p>
    <ul>
      <li>you have given your express consent in accordance with Art. 6 para. 1 sentence 1 lit. a GDPR,</li>
      <li>
        the disclosure pursuant to Art. 6 para. 1 sentence 1 lit. f GDPR is necessary for the assertion, exercise or
        defense of legal claims and there is no reason to assume that you have an overriding interest worthy of
        protection in not disclosing your data,
      </li>
      <li>there is a legal obligation for us to pass on the data in accordance with Art. 6 para. 1 sentence 1 lit. c GDPR, or</li>
      <li>
        this is legally permissible and, in accordance with Art. 6 para. 1 sentence 1 lit. b GDPR, is necessary for
        the fulfilment of contractual relationships with you.
      </li>
    </ul>
    <p>
      A transfer of your personal data to service providers in a third country will only take place if the special
      requirements of Art. 44 ff. GDPR are fulfilled.
    </p>
    <p>
      If you have any further questions regarding the transfer to the relevant third country, please contact us,
      for example by e-mail or by post. You will find the contact details in section A.
    </p>
  </section>
  <section id="section-e">
    <h3 class="letter-heading">E. How do we secure your personal data?</h3>
    <p>
      We use technical and organizational security measures to protect your personal data from accidental or intentional
      manipulation, loss, destruction or access by unauthorized persons. Our security measures are continuously revised
      in line with technological developments.
    </p>
    <p>
      If you have any further questions regarding the used technical and organizational measures, please contact us,
      for example by e-mail or by post. You will find the contact details in section A.
    </p>
  </section>
  <section id="section-f">
    <h3 class="letter-heading">F. What rights do you have?</h3>
    <p>
      You have certain rights under the General Data Protection Regulation including the right to request a copy of
      the personal information we hold about you, if you request it from us in writing:
    </p>
    <p>
      <b>Right to access:</b> the right to obtain access to your information (if we’re processing it), and certain
      other information (like that provided in this Privacy Policy);
    </p>
    <p>
      <b>Right to correct:</b> if your personal information is inaccurate or incomplete you have the right to have
      your personal information rectified;
    </p>
    <p>
      <b>Right to erasure:</b> this is also known as ‘the right to be forgotten’ and, in simple terms, enables you to
      request the deletion or removal of your information where there’s no compelling reason for us to keep using it.
      This is not a general right to erasure; there are exceptions. For example, we have the right to continue using
      your personal data if such use is necessary for compliance with our legal obligations or for the establishment,
      exercise or defense of legal claims;
    </p>
    <p>
      <b>Right to restriction of processing:</b> the right to suspend the usage of your personal information or limit
      the way in which we can process it. Please note that this right is limited in certain situations: When we are
      processing your personal information that we collected from you with your consent you can only request
      restriction on the basis of: (a) inaccuracy of data; (b) where our processing is unlawful and you don’t want your
      personal information erased; (c) you need it for a legal claim; or (d) if we no longer need to use the data for
      the purposes for which we hold it. When processing is restricted, we can still store your information, but may
      not use it further. We keep lists of people who have asked for restriction of the use of their personal
      information to make sure the restriction is respected in future;
    </p>
    <p>
      <b>Right to data portability:</b> the right to request that we move, copy or transfer (where technically feasible)
      your personal information in a structured, commonly used and machine-readable format, for your own purposes
      across different services;
    </p>
    <p>
      <b>Right to object:</b> the right to object to our processing of your personal information including where we
      process it for our legitimate interests, direct marketing;
    </p>
    <p>
      <b>Right to withdraw consent:</b> if you have given your consent to anything we do with your personal information,
      you have the right to withdraw your consent at any time (although if you do so, it does not mean that anything we
      have done with your personal information with your consent up to that point is unlawful).
    </p>
    <p>
      Exercising these rights is free of charge. However, you are required to prove your identity by means of a
      two-factor-authentication. We will engage reasonable efforts consistent with our legal duty to supply,
      correct or delete personal information about you.
    </p>
    <p>
      To exercise your rights, please contact us, for example by e-mail or by post. You will find the contact
      details in section A.
    </p>
  </section>
  <section id="section-g">
    <h3 class="letter-heading">G. Where can you complain?</h3>
    <p>
      You also have the right to lodge a complaint with a data protection supervisory authority regarding our
      processing of your personal data.
    </p>
    <p>Our Lead Data Protection Authority:</p>
    <br>State Commissioner for Data Protection and Freedom of Information, North Rhine-Westphalia (Landesbeauftragte
    für Datenschutz und Informationsfreiheit Nordrhein-Westfalen)
    <br>Kavalleriestr. 2-4
    <br>40213 Düsseldorf
    <br>Germany
    <p>
      Should you really have a reason to make a complaint, you are welcome to contact our Group Data Protection Officer,
      as mentioned above, at any time (contact data see Section A).
    </p>
  </section>
  <section id="section-h">
    <h3 class="letter-heading">H. Data protection for minors</h3>
    <p>
      This website is intended for persons who are at least 18 years old. If a minor submits personal data via this
      website, we will delete this data and not process it further as soon as we become aware of this fact.
    </p>
    <p></p>
  </section>
</div>
